import React from 'react';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import styles from './style';

const useStyles = makeStyles(styles);

export default function ClaimsButton({
  fullWidth = false,
  onClick,
  variant = 'contained',
  size,
  className,
  color = 'primary',
  disabled = false,
  startIcon,
  children,
  ...rest
}) {
  const classes = useStyles();
  return (
    <Button
      fullWidth={fullWidth}
      onClick={onClick}
      variant={variant}
      size={size}
      disabled={disabled}
      startIcon={startIcon}
      className={classNames(
        {
          [classes.root]: !fullWidth,
          [classes[`${color}_${variant}`]]: !disabled,
        },
        className,
      )}
      {...rest}
    >
      {children}
    </Button>
  );
}
